/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { TemplateExpressionTokenType } from "./TemplateExpressionTokenType";
var TemplateExpressionToken = /** @class */ (function () {
    function TemplateExpressionToken() {
    }
    TemplateExpressionToken.EndOfData = {
        Type: TemplateExpressionTokenType.EndOfData,
        Value: null,
        StartPosition: null,
        EndPosition: null
    };
    return TemplateExpressionToken;
}());
export { TemplateExpressionToken };
